export function hydrateImages(slider) {
  slider.find('img[data-src]').each(function () {
    if (!this.src || this.src === 'data:,') {
      this.src = this.dataset.src;
    }
  });
}

// debounce helper
export function debounce(fn, wait){
  let t;
  return function(){
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, arguments), wait);
  }
}

export function loadStyles(files, basePath = 'static/') {
  files.forEach(file => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = basePath + file;
    document.head.appendChild(link);
  });
}